import { feedbacksService } from '@services';
import { feedbacksConstants } from '@constants/feedbacks';

export const feedbacksActions = {
    getAll,
    loadMore,
    resetLoading,
    resetNewExist,
    checkNewExistSuccess,
    update,
    refetch,
};

function getAll(params, pageToken = null, pageSize = 25) {
    return dispatch => {
        dispatch(request());
        feedbacksService.getAll(params, pageToken, pageSize).then(
            data => dispatch(successAll(data)),
            () => dispatch(failure()),
        );
    };
}

function loadMore(params, pageToken, pageSize = 25) {
    return dispatch => {
        feedbacksService.getAll(params, pageToken, pageSize).then(
            data => dispatch(successLoadMore(data)),
            () => dispatch(failure()),
        );
    };
}

function refetch(params, pageToken = null, pageSize = 25) {
    return dispatch => {
        feedbacksService.getAll(params, pageToken, pageSize).then(
            data => dispatch(successRefetch(data)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: feedbacksConstants.FEEDBACKS_REQUEST };
}

function failure() {
    return { type: feedbacksConstants.FEEDBACKS_ERROR };
}

function successAll(payload) {
    return { type: feedbacksConstants.FEEDBACKS_SUCCESS, payload };
}

function successLoadMore(payload) {
    return { type: feedbacksConstants.FEEDBACKS_LOAD_MORE_SUCCESS, payload };
}

function successRefetch(payload) {
    return { type: feedbacksConstants.FEEDBACKS_REFETCH_SUCCESS, payload };
}

function resetLoading() {
    return { type: feedbacksConstants.RESET_LOADING };
}

function checkNewExistSuccess(payload) {
    return { type: feedbacksConstants.NEW_FEEDBACK_EXIST_SUCCESS, payload };
}

function resetNewExist() {
    return { type: feedbacksConstants.NEW_FEEDBACK_EXIST_RESET };
}

function update(payload) {
    return { type: feedbacksConstants.FEEDBACKS_UPDATE, payload };
}
